export const MY_WALLET_QUERY_STALE_MS = 1000 * 60 * 5

export const MY_WALLET_QUERY_RETRIES = 2
